<template>
  <div style="background-color: white">
    <el-row style="padding-top: 10px">
      <el-col :span="24">
        <el-button
          size="small"
          class="btn"
          type="primary"
          v-if="show.lr"
          @click="handleCreate"
          >录入</el-button
        >
        <el-button
          size="small"
          class="btn"
          type="primary"
          v-if="show.lr"
          @click="plLr"
          >批量录入</el-button
        >

        <el-button
          size="small"
          type="primary"
          class="btn"
          v-if="show.dctz"
          @click="derive"
          >导出列表</el-button
        >
        <el-button
          size="small"
          type="primary"
          class="btn"
          v-if="show.dcfj"
          @click="dcfj"
          >导出检定附件</el-button
        >
        <el-button size="small" type="primary" class="btn" @click="xzmb"
          >批量导入检定模板下载</el-button
        >
        <el-form
          :inline="true"
          ref="deviceInfo"
          :model="deviceInfo"
          class="demo-form-inline"
          style="float: right !important"
        >
          <el-form-item label="筛选单位">
            <el-cascader
              v-model="deviceInfo.companyCode"
              :options="companyTree"
              :show-all-levels="false"
              :props="props"
              clearable
            ></el-cascader>
          </el-form-item>
          <el-form-item :label="lable.statue">
            <el-select
              v-model="deviceInfo.state"
              filterable
              clearable
              :placeholder="'选择' + lable.statue"
              style="width: 120px"
            >
              <el-option
                v-for="item in options"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="lable.checkTime">
            <el-date-picker
              v-model="deviceInfo.date"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              value-format="yyyy-MM-dd"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-input
              v-model="deviceInfo.content"
              auto-complete="off"
              placeholder="请输入搜索内容"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button size="small" type="primary" @click="findAllClick"
              >查询</el-button
            >
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table
          :header-cell-style="{ textAlign: 'center', background: '#eff3f6' }"
          :cell-style="{ textAlign: 'center' }"
          ref="multipleTable"
          :data="checkData"
          :row-key="getRowKeys"
          @selection-change="changeCheckBoxValue"
          tooltip-effect="dark"
          style="width: 100%; text-align: center"
          stripe
        >
          <el-table-column
            type="selection"
            width="55"
            :reserve-selection="true"
          >
          </el-table-column>
          <el-table-column
            :label="lable.index"
            type="index"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span>{{ scope.$index + (pageIndex - 1) * pagesize + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="id"
            sortable
            :label="lable.id"
            show-overflow-tooltip
          >
            <template slot-scope="scope" show-overflow-tooltip>
              <el-link
                :underline="false"
                @click="details(scope.row)"
                style="color: #4095e5; text-decoration: none"
              >
                {{ scope.row.id }}
              </el-link>
            </template>
          </el-table-column>
          <el-table-column
            prop="glbh"
            sortable
            :label="lable.glbh"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="jdsb"
            sortable
            :label="lable.jdsb"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="ssdw"
            sortable
            :label="lable.companyName"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            sortable
            prop="checkCertificate"
            :label="lable.checkCertificate"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            sortable
            prop="checkTime"
            :label="lable.checkTime"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="jg"
            sortable
            :label="lable.jg"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="nextCheckTime"
            sortable
            :label="lable.nextCheckTime"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="checkStatue"
            sortable
            :label="lable.statue"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span v-if="scope.row.checkStatue == 1" style="color: #4095e5"
                >待确认</span
              >
              <span v-else style="color: blueviolet">检定结束</span>
            </template>
          </el-table-column>
          <el-table-column :label="lable.cz" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-button
                type="text"
                v-if="scope.row.checkStatue == 0 && show.zf"
                @click="deleteCheck(scope.row)"
                >删除</el-button
              >

              <el-button @click="details(scope.row)" type="text"
                >详情</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </el-col>
      <!--分页工具条-->
      <el-col :span="24" class="toolbar" style="margin-top: 5px; height: 35px">
        <el-pagination
          v-if="checkData.length > 0"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pagesize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          style="float: right"
        >
        </el-pagination>
      </el-col>
    </el-row>
    <div
      style="
        position: fixed;
        top: 13%;
        left: 42%;
        height: 50px;
        width: 50px;
        color: #4095e5;
        font-size: 20px;
      "
      @click="checkBoxdialog = true"
      v-if="checkBoxData.length > 0"
    >
      <!-- <i class="iconfont icon-icon-test" style="width:100%;height:100%;font-size: 40px;"></i> -->
      <el-badge :value="checkBoxNumber">
        <img
          src="../../../static/img/selects.png"
          style="width: 70%; height: 70%; font-size: 40px"
        />
        <!-- <span class="iconfont icon-icon-test" style="width:100%;height:100%;font-size: 40px;"></span> -->
      </el-badge>
    </div>
    <!-- 显示购物车列表 -->
    <el-dialog
      title="已选择设备"
      :visible.sync="checkBoxdialog"
      append-to-body
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-button
        type="primary"
        size="mini"
        @click="removeAllCheckbox"
        style="margin-top: -30px; float: left"
        >清空内容</el-button
      >
      <el-table
        :data="checkBoxData"
        v-if="checkBoxNumber > 0"
        :header-cell-style="{ background: '#eff3f6' }"
        style="padding-top: 5px"
      >
        <el-table-column type="selection" width="55" :reserve-selection="true">
        </el-table-column>
        <el-table-column
          :label="lable.index"
          type="index"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span>{{ scope.$index + (pageIndex - 1) * pagesize + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="id"
          sortable
          :label="lable.id"
          show-overflow-tooltip
        >
          <template slot-scope="scope" show-overflow-tooltip>
            <el-link
              :underline="false"
              @click="details(scope.row)"
              style="color: #4095e5; text-decoration: none"
            >
              {{ scope.row.id }}
            </el-link>
          </template>
        </el-table-column>
        <el-table-column
          prop="glbh"
          sortable
          :label="lable.glbh"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="jdsb"
          sortable
          :label="lable.jdsb"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="ssdw"
          sortable
          :label="lable.companyName"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          sortable
          prop="checkCertificate"
          :label="lable.checkCertificate"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          sortable
          prop="checkTime"
          :label="lable.checkTime"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="jg"
          sortable
          :label="lable.jg"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="nextCheckTime"
          sortable
          :label="lable.nextCheckTime"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="checkStatue"
          sortable
          :label="lable.statue"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span v-if="scope.row.checkStatue == 1" style="color: #4095e5"
              >待确认</span
            >
            <span v-else style="color: blueviolet">检定结束</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" style="text-decoration: none">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="removeThisData(scope.row)"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog
      width="30%"
      title="选择文件"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible.sync="innerVisible"
      append-to-body
    >
      <el-form ref="form" :model="form" label-width="80px">
        <el-form-item label="选择">
          <el-upload
            class="upload"
            ref="upload"
            action="string"
            :file-list="fileList"
            :auto-upload="false"
            accept=".xlsx"
            :http-request="uploadFile"
            :on-change="handleChange"
            :on-preview="handlePreview"
            :on-remove="handleRemove"
            multiple="multiple"
          >
            <el-button
              slot="trigger"
              size="small"
              type="primary"
              @click="delFile"
              >选取文件</el-button
            >
          </el-upload>
          <span>上传文件只能是xlsx格式</span>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit()" :loading="uploading" :disabled="uploading"
            >{{ uploading ? '上传中...' : '上传' }}</el-button
          >
          <el-button @click="innerVisible = false" :disabled="uploading">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import {
  selectAllCheck,
  selectAllstatus,
  test,
  derivation,
  findByModule,
  importLr,
  deleteCheckId,
  getBase,
  findByUserIdCompanyTree,
} from "../../api/api";

export default {
  name: "Verification",
  data() {
    return {
      deviceInfo: {
        date: [],
        content: "",
        state: "",
      },
      companyTree: [],
      fileData: [],
      fileList: [],
      form: {},
      lable: {},
      total: 0,
      pageIndex: 1,
      pagesize: 10,
      
      checkBoxdialog: false,
      checkBoxData: [],
      checkBoxNumber: 0,
      options: [],
      checkData: [],
      innerVisible: false,
      uploading: false,
      show: {
        lr: false,
        dctz: false,
        dcfj: false,
        zf: false,
      },
      props: {
        checkStrictly: true,
        label: "companyName",
        value: "companyCode",
        children: "zcompany",
        emitPath: false,

      },
    };
  },
  methods: {
    plLr() {
      this.innerVisible = true;
    },
    getRowKeys(row) {
      return row.id;
    },
    //清空所有内容
    removeAllCheckbox() {
      this.checkBoxData = [];
      this.checkBoxNumber = this.checkBoxData.length;
      this.$refs.multipleTable.clearSelection(); //清除所有选中复选框
      this.checkBoxdialog = false;
    },
    //获取复选框选中数据
    changeCheckBoxValue(val) {
      console.log(val);
      this.checkBoxData = val;
      this.checkBoxNumber = this.checkBoxData.length;
    },
    //移除一条选中内容
    removeThisData(row) {
      let newCheckBoxData = [];
      for (var i = 0; i < this.checkBoxData.length; i++) {
        if (this.checkBoxData[i].id != row.id) {
          // debugger
          newCheckBoxData.push(this.checkBoxData[i]);
        }
      }
      this.checkBoxData = newCheckBoxData;
      if (this.checkBoxData.length > 0) {
        this.$refs.multipleTable.store.states.selection.map((item, index) => {
          if (item.id === row.id) {
            this.$refs.multipleTable.store.states.selection.splice(index, 1);
          }
        });
      } else {
        this.$refs.multipleTable.clearSelection(); //清除所有选中复选框
        this.checkBoxdialog = false;
      }
      this.checkBoxNumber = this.checkBoxData.length;
    },
    derive() {
      this.loadingUtil.showLoading("正在下载中，请稍后……");
      let _this = this;
      var userinfo = JSON.parse(localStorage.getItem("user"));
      let map = {
        start: this.deviceInfo.date == null ? null : this.deviceInfo.date[0],
        end: this.deviceInfo.date == null ? null : this.deviceInfo.date[1],
        content: this.deviceInfo.content,
        state: this.deviceInfo.state,
        jdlx: 0,
        userId: userinfo.userId,
      };
      if (this.checkBoxData.length > 0) {
        map["ids"] = this.checkBoxData.map((item) => item.id).join();
      } else {
        map["ids"] = "";
      }
      derivation(map).then((datas) => {
        const blob = new Blob([datas]);
        const dlink = document.createElement("a");
        if ("download" in document.createElement("a")) {
          // 非IE下载
          const dlink = document.createElement("a");
          dlink.download = "试验检测仪器设备检定校准计划及完成表.doc";
          dlink.style.display = "none";
          dlink.href = URL.createObjectURL(blob);
          document.body.appendChild(dlink);
          dlink.click();
          URL.revokeObjectURL(dlink.href); // 释放URL 对象
          document.body.removeChild(dlink);
        } else {
          // IE10+下载
          navigator.msSaveBlob(
            blob,
            "试验检测仪器设备检定校准计划及完成表.doc"
          );
        }
        _this.loadingUtil.hideLoading();
      });
    },
    xzmb() {
      window.open(getBase() + '/deviceinfo/downloadTemplateFile?fileName=JDMB.xlsx');
    },
    handleCreate() {
      let val = {
        path: "/AddVenfication",
        name: "录入检定",
      };

      this.$router.push({
        path: "AddVenfication",
      });
      this.$store.commit("pushtags", val);
    },
    details(row) {
      let val = {
        path: "/particulars",
        name: "检定祥情",
      };
      sessionStorage.setItem("verficationXQ", true);
      sessionStorage.setItem("id", row.id);
      console.log(this.deviceInfo);
      sessionStorage.setItem("verficationIndex", this.pageIndex);

      sessionStorage.setItem(
        "verficationXQData",
        JSON.stringify(this.deviceInfo)
      );

      this.$router.push({
        path: "particulars",
      });
      this.$store.commit("pushtags", val);
    },
    findAllClick() {
      this.pageIndex = 1;
      this.findAll();
    },
    findAll() {
      var userinfo = JSON.parse(localStorage.getItem("user"));
      if (sessionStorage.getItem("verficationXQ") == "true") {
        if (sessionStorage.getItem("verficationIndex") != undefined) {
          this.pageIndex = sessionStorage.getItem("verficationIndex") * 1;
          if (sessionStorage.getItem("verficationXQ") == "true") {
            sessionStorage.setItem("verficationXQ", false);
            this.deviceInfo = JSON.parse(
              sessionStorage.getItem("verficationXQData")
            );
            sessionStorage.removeItem("verficationXQData");
          }
        }
      }
      let map = {
        start: this.deviceInfo.date == null ? null : this.deviceInfo.date[0],
        end: this.deviceInfo.date == null ? null : this.deviceInfo.date[1],
        content: this.deviceInfo.content,
        state: this.deviceInfo.state,
        jdlx: 0,
        userId: userinfo.userId,
        pageIndex: this.pageIndex,
        pageSize: this.pagesize,
        companyCode: this.deviceInfo.companyCode,
      };
      selectAllCheck(map).then((datas) => {
        // debugger
        let { status, message, data } = datas;
        if (status == 200) {
          // debugger
          this.checkData = data.list;
          this.total = data.total;
        }
      });
    },
    dcfj() {
      if (this.checkBoxData.length > 0) {
        var map = { list: this.checkBoxData.map((item) => item.id) };

        test(map).then((datas) => {
          const blob = new Blob([datas]);
          const dlink = document.createElement("a");
          if ("download" in document.createElement("a")) {
            // 非IE下载
            const dlink = document.createElement("a");
            dlink.download = "检定附件.zip";
            dlink.style.display = "none";
            dlink.href = URL.createObjectURL(blob);
            document.body.appendChild(dlink);
            dlink.click();
            URL.revokeObjectURL(dlink.href); // 释放URL 对象
            document.body.removeChild(dlink);
          } else {
            // IE10+下载
            navigator.msSaveBlob(blob, "检定附件.zip");
          }
        });
      } else {
        this.$message.warning("请选择检定记录"); // .....失败信息
      }
    },
    findAllType() {
      selectAllstatus().then((datas) => {
        let { status, message, data } = datas;
        if (status == 200) {
          for (var i = 0; i < data.length; i++) {
            if (data[i].statusType == "设备检定") {
              this.options.push({
                name: data[i].statusName,
                id: data[i].statue,
              });
            }
          }
        }
      });
    },
    //文件上传
    onSubmit() {
      if (this.fileList[0] == null) {
        this.$message.error("请选择上传的文件"); // .....失败信息
      } else {
        this.uploading = true;
        var formData = new FormData();
        var userinfo = JSON.parse(localStorage.getItem("user"));
        formData.append("userId", userinfo.userId);
        formData.append("file", this.fileList[0].raw); //拿到存在fileList的文件存放到formData中
        //下面数据是我自己设置的数据,可自行添加数据到formData(使用键值对方式存储)
        // debugger
        importLr(formData).then((datas) => {
          let { status, message, data } = datas;
          if (status == 400) {
            this.$message({
              message: message,
              type: "warning",
              duration: 30000,
              showClose: true,
            });
            // this.innerVisible = false;
          } else if (status == 200) {
            this.findAll();
            this.$message({
              message: "上传成功",
              type: "success",
            });
            this.innerVisible = false;
          } else {
            this.$message({
              message: "请求错误",
              type: "error",
            });
          }
          this.fileList = [];
        }).catch(() => {
          this.$message({ message: '上传失败，请重试', type: 'error' });
        }).finally(() => {
          this.uploading = false;
        });
      }
    },
    //作废
    deleteCheck(row) {
      this.$confirm("确定删除该条信息, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        console.log(row);
        var userinfo = JSON.parse(localStorage.getItem("user"));
        var map = {
          id: row.id,
          userId: userinfo.userId,
        };
        deleteCheckId(map).then((datas) => {
          let { status, message } = datas;
          if (status == 400) {
            this.$message({
              message: message,
              type: "error",
            });
          } else if (status == 200) {
            this.$message({
              message: "删除成功",
              type: "success",
            });
            this.findAll();
          } else {
            this.$message({
              message: "请求错误",
              type: "error",
            });
          }
        });
      });
    },

    //点击上传文件触发的额外事件,清空fileList
    delFile() {
      this.fileList = [];
    },
    handleChange(file, fileList) {
      this.fileList = fileList;
    },
    //自定义上传文件
    uploadFile(file) {
      this.formData.append("file", file.file);
    },
    //删除文件
    handleRemove(file, fileList) {},
    // 点击文件
    handlePreview(file) {},

    handleCurrentChange(val) {
      this.pageIndex = val;
      sessionStorage.setItem("verficationIndex", val);
      //contentdata是所有的数据，是一个大数组。使用.slice()方法可以将大数组切分
      //.slice()方法接受两个参数，开始和结束的值
      //这样得到的currentdata就是固定只有10个值的数组了，就可以用v-for展示啦
      this.findAll();
    },
    handleSizeChange(val) {
      this.pagesize = val;
      this.findAll();
    },
    findLable() {
      findByModule("设备检定").then((datas) => {
        let { status, message, data } = datas;
        if (status == 200) {
          this.lable = data;
        }
      });
    },
    getCompanyTree() {
      var userinfo = JSON.parse(localStorage.getItem("user"));
      var  companyCode='';
      if (userinfo.userRole == 1 || (userinfo.fjqx != null && (userinfo.fjqx.indexOf ("3")!=-1||userinfo.fjqx.indexOf ("4")!=-1))) {
        companyCode="-1"
      }else{
        companyCode=userinfo.companyCode
      }
      findByUserIdCompanyTree(companyCode).then((datas) => {
        let { status, message, data } = datas;
        if (status == 200) {
          this.companyTree = this.getTreeData(data);
        }
      });
    },
    getTreeData(data) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].zcompany.length < 1) {
          // 最后一级没有数据将children变成undefined
          data[i].zcompany = undefined;
        } else {
          // children不为空时继续调用该方法
          this.getTreeData(data[i].zcompany);
        }
      }
      return data;
    },
  },
  created() {
    this.findLable();
    this.findAll();
    this.findAllType();
    this.getCompanyTree();
    var userinfo = JSON.parse(localStorage.getItem("user"));
    var arr = userinfo.role.menuId.split(",");
    arr.forEach((i) => {
      if (i == "87") {
        this.show.lr = true;
      }
      if (i == "88") {
        this.show.dctz = true;
      }
      if (i == "89") {
        this.show.dcfj = true;
      }
      if (i == "91") {
        this.show.zf = true;
      }
    });
  },
  // keep-alive 缓存后重新激活时，保留搜索条件刷新列表
  activated() {
    this.findAll();
  },
};
</script>
<style >
.el-checkbox__inner {
  border: 1px solid #606266 !important;
}
</style>
<style scoped>
.btn {
  float: left;
  margin-left: 5px;
}
</style>



// WEBPACK FOOTER //
// src/views/verification/Verification.vue